import React from "react";
import PageFrame from "./PageFrame";
import { REALTOR } from "../lib/brand";

export default function BackCoverPage({ pageNum, totalPages }) {
    return (
        <PageFrame pageNum={pageNum} totalPages={totalPages} label="Closing">
            <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32 text-center w-full flex-1 flex flex-col items-center justify-center">
                <div className="h-px w-24 bg-gold mx-auto mb-12" />
                <p className="serif-display italic text-4xl sm:text-5xl md:text-6xl text-navy leading-tight">
                    "{REALTOR.tagline}"
                </p>
                <div className="h-px w-24 bg-gold mx-auto mt-12 mb-10" />
                <div className="serif-display text-3xl text-navy">{REALTOR.name}</div>
                <div className="mt-3 font-sans text-xs tracking-[0.22em] uppercase text-muted2">
                    REALTOR® · {REALTOR.companyRealty}
                </div>
                <div className="font-sans text-xs tracking-[0.22em] uppercase text-muted2 mt-1">
                    Loan Originator · {REALTOR.companyMortgage}
                </div>
                <div className="mt-10 font-sans text-xs tracking-[0.22em] uppercase text-coral">
                    Confidential · Prepared exclusively for your relocation
                </div>
            </div>
        </PageFrame>
    );
}
